import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import { store } from "./app/store";
import { Provider } from "react-redux";
import AuthProvider from "./context/AuthContext";
import StateProvider_KO from "./context/StateContext_KO";
import StateProvider_US from "./context/StateContext_US";
import ProductProvider from "./context/ProductContext";
import { useLocation } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { ConfirmProvider } from "material-ui-confirm";
import { useTranslation, withTranslation, Trans } from "react-i18next";

import "./i18n.js";
import "./index.css";

ReactDOM.render(
  <AuthProvider>
    <StateProvider_KO>
      <StateProvider_US>
        <ProductProvider>
          <Provider store={store}>
            <Router>
              <ConfirmProvider>
                <App />
              </ConfirmProvider>
            </Router>
          </Provider>
        </ProductProvider>
      </StateProvider_US>
    </StateProvider_KO>
  </AuthProvider>,
  document.getElementById("root")
);
